// this file is generated by update_shopify_store_data.py at 2026-08-24 20:19:30.206273
var courses = [];